import React from "react";
import { initials } from "../utils/format";
import logo from "../assets/logo.svg";
import CalendarIcon from "./schedule/CalendarIcon";

export default function AppHeader({ user, canAdd, exporting, onOpenCalendar, onOpenUsers, onExport, onNew, onLogout }) {
  return (
    <header className="app-header no-print">
      <div className="header-left">
        <div className="brand-logo">
          <img src={logo} alt="DOTIZO ADVERTISING.LLC" className="brand-logo-img" />
        </div>
        <div className="header-divider"></div>
        <div className="system-title">
          <h1>Job Register Portal</h1>
          <span className="online-badge">
            <span className="pulse-dot"></span> Cloud Live Sync
          </span>
        </div>
      </div>
      <div className="header-actions">
        <button type="button" className="btn btn-secondary" title="View Calendar & Schedule" onClick={() => onOpenCalendar()}>
          <CalendarIcon className="btn-icon" />
          Calendar &amp; Schedule
        </button>
        {onOpenUsers && (
          <button type="button" className="btn btn-secondary" title="Manage Job Order users" onClick={onOpenUsers}>
            <svg viewBox="0 0 24 24" className="btn-icon"><path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" /></svg>
            Users
          </button>
        )}
        <button
          type="button"
          className="btn btn-secondary"
          title="Export the job register (current filters) to a CSV file that opens in Excel"
          onClick={onExport}
          disabled={exporting}
        >
          <svg viewBox="0 0 24 24" className="btn-icon"><path fill="currentColor" d="M5 20h14v-2H5v2zm0-10h4v6h6v-6h4l-7-7-7 7z" /></svg>
          {exporting ? "Exporting..." : "Export CSV"}
        </button>
        {canAdd && (
          <button type="button" className="btn btn-primary" onClick={onNew}>
            <svg viewBox="0 0 24 24" className="btn-icon"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" /></svg>
            New Job Order
          </button>
        )}

        <div className="header-user-profile">
          <div className="user-avatar">{initials(user.name)}</div>
          <div className="user-details">
            <span className="user-name">{user.name || "Portal User"}</span>
            <span className="user-email">{user.email || ""}</span>
          </div>
          <button type="button" className="btn-logout-icon" title="Sign Out of Portal" onClick={onLogout}>
            <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" /></svg>
          </button>
        </div>
      </div>
    </header>
  );
}
